import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";

import { clx } from "../../../../../../utils/Helpers";
import "../../../_EventDetailFields.scss";

const ShiftField = ({ label, children, accent, valueClassName, md }) => (
  <Grid item xs={12} sm={6} md={md}>
    <div className="event-detail-field">
      <span className="event-detail-label">{label}</span>
      <div
        className={clx("event-detail-value", valueClassName, {
          "event-detail-value--accent": accent,
        })}
      >
        {children}
      </div>
    </div>
  </Grid>
);

ShiftField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  accent: PropTypes.bool,
  valueClassName: PropTypes.string,
  md: PropTypes.number,
};

ShiftField.defaultProps = {
  accent: false,
  valueClassName: "",
  md: 3,
};

export default ShiftField;
